import { utils, writeFile } from 'xlsx';
import { toCurrencyAmountValue } from 'helpers/currencyHelper';
import { generateDateTimeFilename } from 'helpers/dateHelper';

export interface BalanceData {
  amount: string;
  availableAmount: string;
  balanceId: string;
  balanceTitle: string;
  balanceType: string;
  currency: string;
  currencyCode: string;
  updatedAt: string;
}

export interface BalanceTotals {
  amount: string,
  currency: string
}

type ExcelRow = Array<string | number>;

// Маппинг ID полей к названиям строк в Excel
const ROW_LABELS = {
  balanceTitle: 'Balance Name',
  balanceType: 'Balance Type',
  updatedAt: 'Latest Operation',
  amount: 'Amount',
  availableAmount: 'Available Amount',
  currency: 'Currency',
};

// Порядок строк в Excel
const ROW_ORDER = [
  'balanceTitle',
  'balanceType',
  'updatedAt',
  'amount',
  'availableAmount',
  'currency',
];

function generateRealTimeBalanceExcel(
  data: BalanceData[],
  totals: BalanceTotals[],
) {
  const wb = utils.book_new();
  const excelData: ExcelRow[] = [];

  const headers: string[] = [
    'Total balance amount (by currency)',
    '',
    ...Object.values(ROW_LABELS),
  ];

  excelData.push(headers);

  data.forEach((balance: BalanceData, index: number) => {
    const rowData: ExcelRow = [];

    rowData.push('');
    rowData.push('');

    ROW_ORDER.forEach((rowId) => {
      rowData.push(balance[rowId]);
    });

    excelData.push(rowData);
  });

  const ws = utils.aoa_to_sheet(excelData);

  const colWidths = [{ wch: 30 }, { wch: 10 }];
  ROW_ORDER.map(() => colWidths.push({ wch: 20 }));
  ws['!cols'] = colWidths;

  // Add totals rows
  utils.sheet_add_aoa(
    ws,
    totals.map(value => [
      toCurrencyAmountValue(value.amount, value.currency),
    ]), { origin: 'A2' },
  );

  utils.book_append_sheet(wb, ws, 'Balance Real-Time');
  const fileName: string = generateDateTimeFilename('xlsx', 'real_time_balance_');

  writeFile(wb, fileName);
}

export { generateRealTimeBalanceExcel };
